import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState } from "react";
import Home from './pages/Home/Home';
import Homenew from './pages/Home/Homenew';
import AboutUs from "./pages/About/AboutUs";
import ContactUs from './pages/Contact/ContactUs';
import CreateProfile from './pages/CreateProfile/CreateProfile'
import ManagementTeam from './pages/ManagementTeam/ManagementTeam'
import Events from './pages/Events/Events';
import ProfileDashboard from './pages/ProfileDashboard/ProfileDashboard';
import Subscription from './pages/Subscription/Subscription';
import EventDetails from './pages/EventDetails/EventDetails';
import TermsConditions from './pages/TermsConditions/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ChildSafetyStandards from './pages/ChildSafetyStandards/ChildSafetyStandards';
import PageHeader from "./pages/Header";
import PageFooter from "./pages/Footer";
import ScrollToTop from './ScrollToTop';

// NEW REUSABLE COMPONENTS: Authentication Route Guards
const ProtectedRoute = ({ children }) => {
    const isLoggedIn = !!localStorage.getItem("token");
    // If the token is missing from storage, force-redirect back to the landing page
    return isLoggedIn ? children : <Navigate to="/" replace />;
};

const PublicOnlyRoute = ({ children }) => {
    const isLoggedIn = !!localStorage.getItem("token");
    // If a logged-in user explicitly navigates to the home/login page, route them back to the active dashboard
    return !isLoggedIn ? children : <Navigate to="/dashboard" replace />;
};

function App() {
    // Dynamically respects "/" or "/vmm" base routing prefix via your .env setup
    const routerBasename = process.env.REACT_APP_ROUTER_BASENAME || "/";
    const [loading, setLoading] = useState(false);
    return (
        <Router basename={routerBasename}>
            <div className="App">
                {loading && (
                <div className="page-loader">
                    <img
                    className="loader_logo"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/vmm_logo.png`}
                    alt="Logo"
                />
                <p className="loader_logo_name">Vikas Mandal Mulund</p>
                    <div className="ring"></div>
                </div>
                )}
                <ScrollToTop />
                <PageHeader />
                <Routes>
                    {/* Publicly Available Pages accessible to everyone */}
                    <Route path="/home2" element={<Homenew />} />
                    <Route path="/AboutUs" element={<AboutUs />} />
                    <Route path="/ContactUs" element={<ContactUs />} />
                    <Route path="/ManagementTeam" element={<ManagementTeam />} />
                    <Route path="/Events" element={<Events />} />
                    <Route path="/EventDetails" element={<EventDetails />} />
                    <Route path="/TermsConditions" element={<TermsConditions />} />
                    <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="/ChildSafetyStandards" element={<ChildSafetyStandards />} />

                    {/* Guest / Public Only Route: Automatically redirects to dashboard if session exists */}
                    <Route
                        path="/"
                        element={
                            <PublicOnlyRoute>
                                <Home />
                            </PublicOnlyRoute>
                        }
                    />

                    {/* AUTHENTICATION PROTECTED ROUTES: Redirects instantly back to "/" if session does not exist */}
                    <Route
                        path="/CreateProfile"
                        element={
                            <ProtectedRoute>
                                <CreateProfile />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <ProfileDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/subscription"
                        element={
                            <ProtectedRoute>
                                <Subscription />
                            </ProtectedRoute>
                        }
                    />

                    {/* Catch-all global fallback redirect for completely broken or non-existent URLs */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>

                <PageFooter />
            </div>
        </Router>
    );
}

export default App;